// Copyright (c) 2017 Deere & Company

import './index.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import AuditPreparation from '@deere/cps-it.warranty-model-factory/lib/audit-preparation';
import PrepareAuditAside from './prepare-audit-aside';
import PrepareAuditHeader from './prepare-audit-header';
import PrepareAuditMain from './prepare-audit-main';
import SystemSelectedClaimsModal from './system-selected-claims-modal';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleSaveAudit() {

    this.actions.saveAudit();

}

function handleOnSystemSelectedClaimsModalClose() {

    this.actions.updateSystemSelectedClaimsModalVisibility(false);

}

function handleOnSelectClaims(fromDate, toDate) {

    this.actions.updateSystemSelectedClaimsModalVisibility(false);
    this.actions.readNewSystemSelectedClaims(fromDate, toDate, this.auditPreparation);

}

function handlePrintClaimsButtonClick() {

    this.actions.readAuditCreditMemoClaims(this.auditPreparation.claims, this.user.getLocale());

}

function handlePrintCreditMemoButtonClick() {

    this.actions.readAuditCreditMemos(this.auditPreparation.claims, this.user.getLocale());

}

class PrepareAudit extends Component {

    componentWillMount() {

        if (this.props.auditPreparation.claims.length < 1) {

            this.props.queryParams.auditNumber ?
                this.props.actions.readPreparedAudit(this.props.queryParams.auditNumber, this.props.queryParams.d) :
                this.props.actions.readUnpreparedAudit(this.props.queryParams.d);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetAuditPreparation();
        this.props.actions.updateSystemSelectedClaimsModalVisibility(false);

    }

    render() {

        return (
            this.props.children || <section className='prepare-audit'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <PrepareAuditHeader
                    auditPreparation={this.props.auditPreparation}
                    isAuditLoaded={this.props.isAuditLoaded}
                    onPrintClaimsButton={this.props::handlePrintClaimsButtonClick}
                    onPrintCreditMemoButton={this.props::handlePrintCreditMemoButtonClick}
                    onSaveAudit={this.props::handleSaveAudit}
                />
                <div className='prepare-audit-info'>
                    <PrepareAuditMain/>
                    <PrepareAuditAside count={this.props.auditPreparation.userSelectedClaimsMinimum}/>
                </div>
                <SystemSelectedClaimsModal
                    dateFieldPlaceholder={this.props.user.getDateFormatValue()}
                    isSystemSelectedClaimsModalVisible={this.props.isSystemSelectedClaimsModalVisible}
                    onModalClose={this.props::handleOnSystemSelectedClaimsModalClose}
                    onSelectClaims={this.props::handleOnSelectClaims}
                />
            </section>
        );

    }

}

PrepareAudit.displayName = 'PrepareAudit';
PrepareAudit.propTypes = {
    actions: PropTypes.object.isRequired,
    auditPreparation: PropTypes.instanceOf(AuditPreparation).isRequired,
    busyCounter: PropTypes.number.isRequired,
    children: PropTypes.node,
    isAuditLoaded: PropTypes.bool.isRequired,
    isSystemSelectedClaimsModalVisible: PropTypes.bool.isRequired,
    queryParams: PropTypes.object.isRequired,
    user: PropTypes.instanceOf(User).isRequired
};

export default PrepareAudit;



// WEBPACK FOOTER //
// ./src/tcsm/prepare-audit/components/index.js